<sv-toolbar class="toolbar" />
<sv-navigation-bar class="navigation" />

<div class="content">
  <router-outlet></router-outlet>
</div>
